import { combineEpics } from 'redux-observable';
import { appSettingsEpic } from '../features/app-settings/app-settings-epic';

export const rootEpic = combineEpics<any>(appSettingsEpic);
